import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import SidePage from '@/shared/SidePage'
import { useState } from 'react'
import EditOrganizationSidePageContent from '@/pages/Organizations/components/OrganizationSidePage/EditOrganizationSidePageContent'
import ViewOrganizationSidePageContent from '@/pages/Organizations/components/OrganizationSidePage/ViewOrganizationSidePageContent'

interface IProps {
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
  organization: IOrganization
}

const OrganizationSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    if (pageMode === 'edit') {
      return <EditOrganizationSidePageContent organization={props.organization} onCancel={() => setPageMode('view')} />
    }

    return (
      <ViewOrganizationSidePageContent
        organization={props.organization}
        onEdit={() => setPageMode('edit')}
        onClose={props.onClose}
      />
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.organization) return null

  return <OrganizationSidePage {...props} />
}
